// extracted by mini-css-extract-plugin
export var standaloneTable = "_hh-0";
export var standaloneTableWithBodyFill = "_hh-1";
export var withExtraHeader = "_hh-2";